import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import getUserInfo from 'redux/actions/users/getUserInfo';

const useResponse = () => {
  const dispatch = useDispatch();
  const {
    user: {
      operation,
      walletUpdate,
      myWallets: { walletList },
      userData: { data: userData, loading: userDataLoading },
    },
    providersCountries: { providersList, providersCountries },
    payBills: {
      verifyGatewayAccounts,
      getBillsCategories: { billsCategories },
    },
    moneyTransfer: {
      gatewayTransactionConfirmation,
      sendFundsToGateway,
    },
    contacts: { locateWallet },
  } = useSelector(state => state);

  useEffect(() => {
    if (localStorage.token && !userDataLoading && !userData?.OperationCountry) {
      getUserInfo()(dispatch);
    }
  }, [userDataLoading, userData?.OperationCountry]);

  return {
    walletUpdate: walletUpdate,
    verifiedGatewayAccount: verifyGatewayAccounts,
    walletList: walletList,
    currentUser: userData,
    operations: operation?.data,
    providersData: providersList,
    providersCountries: providersCountries,
    billsCategories: billsCategories,
    requestFundsToGateway: sendFundsToGateway,
    transactionConfirmation: gatewayTransactionConfirmation,
    locateUser: locateWallet,
  };
};

export default useResponse;
